export default __webpack_public_path__ + "static/media/hht2_direction_sitcom.e8cf0c8b.png";